import { z } from 'zod'

export const InspectionBinBoundsSchema = z
  .object({
    x_start: z.number().int().nonnegative(),
    x_end: z.number().int().positive(),
    y_start: z.number().int().nonnegative(),
    y_end: z.number().int().positive(),
  })
  .refine(
    (bounds) => bounds.x_end > bounds.x_start && bounds.y_end > bounds.y_start
  )
export type InspectionBinBounds = z.infer<typeof InspectionBinBoundsSchema>
